
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.3 9h17-17zm15.455 10H2.845c-.852 0-1.545-.717-1.545-1.6V4.602C1.3 3.717 1.993 3 2.845 3h13.91c.852 0 1.545.717 1.545 1.602V17.4c0 .883-.693 1.6-1.545 1.6zM5.3 2v4-4zm9 0v4-4z","stroke":"#24C4C8","stroke-width":"2.2","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    